<template>
  <div>
    <public-title>待审核列表</public-title>
    <div class="bg-white load-area">
        <ul class="order-tab mb-3">
            <li v-for="tab in tabArr()" :key="tab.status" :class="{'tab-active':tab.status==formData.status}" @click="changeTab(tab.status)">
                <i :class="tab.icon " class="iconfont"></i>
                {{ tab.title }}
                <span v-if="infoNum[tab.value]>0" class="order-num" :class="tab.color">{{infoNum[tab.value]}}</span>
            </li>
        </ul>
        <!--列表-->
        <div v-if="list.length>0&&!loading">
            <ReportList :list="list" :review="true"></ReportList>  
            <!--分页-->
            <div class="el-pagination">
            <el-pagination background layout="total,prev, pager, next" 
                :page-size="10"
                :total="total" :current-page="Number(formData.page)"
                @current-change="$GFUN.pageChange"/>
            </div>
        </div>
        <!--暂无信息-->
        <div class="no-data" v-if="list.length==0&&!loading">
            <NoPrompt></NoPrompt>
        </div>
        <div v-if="loading">
            <Spinner :quotation="1"></Spinner>
        </div>
    </div>
  </div>
</template>

<script>
 import ReportList from '../Components/ReportList.vue'                         //订单列表组件
 import  Spinner from '../Components/Spinner'                                  //骨架屏组件
 import  NoPrompt from '../Components/NoPrompt.vue'                            //暂无信息组件
 import { mapGetters,mapActions,mapState} from 'vuex'
 import { debounce } from "lodash";
    export default {
    name: 'InquiryList',
    components: {
        ReportList,
        Spinner,
        NoPrompt,
    },
    props: {},
    data() {
        return {
            formData:{
                page:1,
                status:1,
                num:10,
            },
            list: [],
            total: 0,
            loading: true,
            //标记数量
            infoNum:{
                status_1:0,
                status_2:0,
                status_3:0,
            },
        };
    },
    computed: {
        ...mapState(['newMessageInform',]),
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),

    },
    watch: {
        newMessageInform(newVal) {
            //收到通知刷新当前页面
            if (newVal && this.$GFUN.isInArray([4],newVal.type)){
                this.getOrderList();
            }
        },
        '$route.query':{
            handler(toVal,fromVal){
                this.formData.status=toVal.status||1;
                this.formData.page=toVal.page||1
                this.getOrderList();
            },
            immediate:true
        }
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions(['POST_Admin_OrderHotelPendingList']),
        getOrderList: debounce(function() {
            let data=this.formData;
            this.loading = true
            this.POST_Admin_OrderHotelPendingList({data,successFun:(res)=>{
                this.loading = false;
                //更新标记数量
                this.infoNum=res.info;
                this.total = res.count;
                this.list = res.list;

            }});
        },300),
        //切换搜索分类
        tabArr() {  
            let tabArr = [
                {title: '待审核', status: '1' ,icon:'icon-qinggoudanguanli',value:'status_1'},
                {title: '待匹配', status: '2',value:'status_2',icon:'icon-quanxianziyuanguanli',color:'green'},
            ]
            return tabArr
        },
        //切换搜索分类
        changeTab(status){
            this.formData.page=1;
            //保存到路由
            this.$router.push({
                name: this.$route.query.name,
                query: {status:status, page: 1,}
            })
            this.formData.status=status;
            this.searchCon={};
        },
    },
    };
</script>

<style lang="scss" scoped>
    .load-area{
        background-color:inherit !important;
        padding:0 !important;
        min-width: 1200px;
    }
    .text-psis{
        background-color: #f5f6f9;
        color: #6e7789;
        padding: 6px 8px;
        border-radius: 4px;
        font-size: 12px;
    }
    .el-pagination{
        background-color: #fff;
        margin-top:14px;
        padding-bottom:10px;
    }
    .order-tab{
        display: flex;
        justify-content: left;
        width: 100%;    

        box-sizing: border-box;
        li{
            margin-right: 20px;
            padding: 10px 20px;
            background-color: #fff;
            border-radius: 5px;
            display: flex;
            align-items: center;
            color: #666;
            cursor: pointer;
            i{
                margin-right: 5px;
                font-size: 18px;
                margin-top: 2px;
            }
            .order-num{
                margin-left: 10px;
                background-color: red;
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                border-radius: 50%;
                margin-top: 1px;
                font-weight: bold;
                font-size: 11px;
                color: #fff !important;
            }
        }
        .tab-active{
            background-color: var(--smtc-color-primary);
            color: #fff;
        }
    }
</style>